module.exports = __webpack_public_path__ + "static/media/image 7.1a089a4f.png";